export const get_dashboard_report_type = "GET_DASHBOARD_REPORT";
export const get_dashboard_report_Success_type = "GET_DASHBOARD_REPORT_SUCCESS";
export const get_dashboard_report_Failed_type = "GET_DASHBOARD_REPORT_FAILED";


export const cache_dashboard_query_response_type = "CACHE_DASHBOARD_QUERY_RESPONSE";
export const update_allreport_boolean = "UPDATE_ALL_REPORT_BOOLEAN";